import {
  Component,
  ElementRef,
  ViewChild,
  Inject,
  Injectable,
  PLATFORM_ID,
} from '@angular/core';
import { MenuItem, MessageService, PrimeNGConfig } from 'primeng/api';
import { Sidebar } from 'primeng/sidebar';
import { createChart, Time } from 'lightweight-charts';
import { SocketServiceService } from './shared/services/socket-service/socket-service.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ScreenResolutionService } from './shared/services/screen-resolution/screen-resolution.service';
import { DataSharingService } from './shared/services/data-sharing/data-sharing.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  isBrowser = false;

  showHeader = true;
  showFooter = true;
  isMobile: boolean = false;
  bottomNav = true;
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private router: Router,
    private screenResolution: ScreenResolutionService,
    private dataSharingService: DataSharingService,
    private messageService: MessageService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  ngOnInit() {
    this.isMobile = this.screenResolution.isMobile();
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const currentUrl = event.urlAfterRedirects.split('?')[0];

        this.showHeader = ![
          '/user/login',
          '/user/signup',
          '/signup',
          '/user/forgot-password',
          '/user/verify-otp',
        ].includes(currentUrl);
        if (this.isMobile) {
          this.showHeader = ['/trading/market', '/fees'].includes(currentUrl);
        }
        if (!this.isMobile) {
          this.showFooter = [
            '/trading/market',
            '/home',
            '/about',
            '/support',
            '/fees',
            '/aml-policy',
            '/privacy-policy',
            '/terms-conditions',
            '/risk-disclosure',
          ].includes(currentUrl);
        }
        this.bottomNav = [
          '/trading/market',
          '/trading/pairs',
          '/trading/chart',
          '/user/account',
        ].includes(currentUrl);
      });
  }
}
